"use client";

import type { ReactNode } from "react";
import { CloudOff, RefreshCcw } from "@/components/icons";
import { ErrorBoundary } from "@/components/error/error-boundary";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function LoadFailureNotice({
  title,
  onRetry,
  className,
}: {
  title: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        "flex w-full flex-col items-center justify-center gap-2.5 rounded-sm border border-border bg-muted px-4 py-5 text-center text-sm",
        className,
      )}
    >
      <CloudOff aria-hidden="true" className="size-5 text-muted-foreground" />
      <p className="font-medium text-foreground">{title}</p>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onRetry ?? (() => window.location.reload())}
      >
        <RefreshCcw className="size-3.5" />
        {onRetry ? "Try again" : "Refresh page"}
      </Button>
    </div>
  );
}

export function LoadFailureBoundary({
  label,
  title,
  className,
  children,
}: {
  label: string;
  title: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <ErrorBoundary
      label={label}
      fallback={(reset) => (
        <LoadFailureNotice title={title} onRetry={reset} className={className} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
